/**
 * Een periode van lokale dagen als twee tijdstippen. Uit `VluchtrecorderBlok.jsx`
 * gehaald op 21 oktober 2026 (los punt wintertijdtoets), zodat de toets op de dag van
 * de wintertijd deze module in een EIGEN proces met TZ=Europe/Amsterdam kan laden.
 *
 * GEEN IMPORTS IN DIT BESTAND. De toets laadt het als data-URL, en een data-URL kan
 * geen relatief pad oplossen; een import hier breekt die toets met de reden erbij.
 *
 * De dag erbij gaat met `setDate`, niet met 24 uur: op de dag van de wintertijd duurt
 * een dag 25 uur.
 */

const DAG = /^\d{4}-\d{2}-\d{2}$/;

function lokaal(dag) {
  const [j, m, d] = dag.split("-").map(Number);
  return new Date(j, m - 1, d, 0, 0, 0, 0);
}

/** De periode als twee ISO-tijdstippen, of null als hij niet klopt. PUUR op de tijdzone. */
export function periodeVan(van, tot) {
  if (!DAG.test(van || "") || !DAG.test(tot || "")) return null;
  const begin = lokaal(van);
  const einde = lokaal(tot);
  einde.setDate(einde.getDate() + 1);
  if (!(begin < einde) || begin > lokaal(tot)) return null;
  return { van: begin.toISOString(), tot: einde.toISOString() };
}

/** Een lokale dag als JJJJ-MM-DD. PUUR op de tijdzone. */
export function dagVan(datum) {
  const p = (n) => String(n).padStart(2, "0");
  return `${datum.getFullYear()}-${p(datum.getMonth() + 1)}-${p(datum.getDate())}`;
}
